import React, { Fragment } from "react"
import Card from "../card"
import NewMessageForm from "../new-message-form"
import PropTypes from "prop-types"

class MessagesArea extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      conversationTitle: props.conversationTitle,
      conversationMessages: props.conversationMessages
    }
  }

  mapMessages(conversationMessages) {
    return conversationMessages.map((message) => {
      return (
        <li key={message.id}>
          {message.text} - from {message.fromUserName} at {message.created_at.toString()}
        </li>
      )
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.conversationMessages !== this.props.conversationMessages) {
      this.setState({
        conversationMessages: this.props.conversationMessages
      })
    }
  }

  render() {
    const { mapMessages } = this
    const { conversationTitle, conversationMessages } = this.state

    console.log(conversationMessages)

    return (
      <Card variant="primary">
        {conversationMessages.constructor === Array && conversationMessages.length > 0 && (
          <Fragment>
            <h1>{conversationTitle}</h1>
            <ul>{mapMessages(conversationMessages)}</ul>
          </Fragment>
        )}

        <NewMessageForm submitHandler={this.props.submitHandler} />
      </Card>
    )
  }
}

MessagesArea.propTypes = {
  conversationTitle: PropTypes.string.isRequired,
  conversationMessages: PropTypes.array.isRequired,
  submitHandler: PropTypes.func.isRequired
}

MessagesArea.defaultProps = {
  conversationTitle: "Conversation",
  conversationMessages: []
}

export default MessagesArea
